import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth.js"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL
const baseUrl = `${PROGUIDES_WEB_URL}api/v2/`

export const fetchBootcampByKey = async key => {
  try {
    const url = `${baseUrl}store/products/bootcamps/${key}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
  }
}

export const fetchBootcampDetailByKey = async key => {
  try {
    const url = `${baseUrl}user/bootcamps/${key}/enrollment`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
  }
}



// WEBPACK FOOTER //
// ./src/api/bootcamp.api.js